<template>
  <div class="layout_containner">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // this.$bus.$on("goTop", () => {
    //   let timer = setTimeout(() => {
    //     document.querySelector("layout_containner").scrollTo(0, 0);
    //     clearTimeout(timer);
    //   });
    // });
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
.layout_containner {
  // width: 100vw;
  // height: 100vh;
  // scroll-snap-stop: always;
  // overflow-y: auto;
  // overflow-x: hidden;
  padding: 0;
  margin: 0;
}
</style>